export class FiltrSlownikowProjektu {
    projektId: string;
    wartoscSzukaj: string;
}